import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../services/firebase";
import "./styles.css";
import Container from "../../../components/Container";
import ValvulaBloqueioClient from "./ValvulaBloqueioClient";
import ValvulaControleForm from "./ValvulaControleForm";
import ValvulaPSVForm from "./ValvulaPSVForm";

function ClientValveForm() {
  const { tipo, id } = useParams();
  const [tipoValvula, setTipoValvula] = useState(0);
  const [valvula, setValvula] = useState();

  async function getValvula() {
    const ref = doc(db, `valvulas${tipo}`, id);
    const snapshot = await getDoc(ref);
    const data = { id: snapshot.id, ...snapshot.data() };
    setValvula(data);
  }

  useEffect(() => {
    async function fetchData() {
      if (tipo === "Bloqueio") setTipoValvula(0);
      if (tipo === "Controle") setTipoValvula(1);
      if (tipo === "PSV") setTipoValvula(2);

      await getValvula();
    }

    if (tipo && id) fetchData();
  }, [tipo, id]);

  return (
    <Container userType="cliente">
      <div className="valve-form-content">
        <div className="valve-form-container">
          <h2 className="form-title">Válvula</h2>
          {tipoValvula === 0 && <ValvulaBloqueioClient valvula={valvula} />}
          {tipoValvula === 1 && <ValvulaControleForm valvula={valvula} />}
          {tipoValvula === 2 && <ValvulaPSVForm valvula={valvula} />}
        </div>
      </div>
    </Container>
  );
}

export default ClientValveForm;
